import type { PaymentGateway } from '@openeducation/pp-rn-shared-types';
import { atom } from 'jotai';

export const selectedPaymentGatewayAtom = atom<PaymentGateway>(
  '' as PaymentGateway
);
